// extracted by mini-css-extract-plugin
module.exports = {"formContact":"FormContact_formContact__2GQtt","errorBox":"FormContact_errorBox__5pksb","textError":"FormContact_textError__1HdF9"};